import { Component, OnInit } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../environments/environment";
import { MatCardModule } from "@angular/material/card";

export interface Realm {
  displayName: string | null;
  clientId: string;
  name: string;
}

@Component({
  selector: "app-auth",
  templateUrl: "./auth.component.html",
  styleUrls: ["./auth.component.css"],
  imports: [MatInputModule, MatFormFieldModule, MatButtonModule, MatCardModule],
  providers: [KeycloakService]
})
export class AuthComponent implements OnInit {
  public tenantId: string = "";
  public isLoggedIn = false;

  constructor(
    private readonly keycloak: KeycloakService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    const state = this.getParameterFromUrl("state");

    if (state) {
      this.router.navigate(["gateway/home"]);
    }
  }

  ngOnInit(): void {
    this.hydrateTenantId();

    this.route.queryParamMap.subscribe((params) => {
      const tenantFromRoute =
        params.get("tenant_id") ?? params.get("tenantId") ?? "";
      const cleanedTenant = tenantFromRoute.trim();
      if (!cleanedTenant) return;

      this.tenantId = cleanedTenant;
      sessionStorage.setItem("tenantId", this.tenantId);
    });
  }

  updateTenantId(event: Event) {
    this.tenantId = (event.target as HTMLInputElement).value.trim();
  }

  handleLoginPress() {
    console.log('[auth] handleLoginPress fired. tenantId:', this.tenantId);
    this.login();
  }

  onSubmit(event: Event) {
    event.preventDefault(); // stop the browser’s default submit
    this.handleLoginPress();
  }

  login() {
    const realm = this.tenantId;
    const clientId = "websiteclient";
    if (clientId && realm) {
      sessionStorage.setItem("tenantId", this.tenantId);
      this.keycloak
        .init({
          config: {
            realm: realm,
            url: environment.KEYCLOAK_URL,
            clientId: "websiteclient",
          },
          initOptions: {
            responseMode: "query",
          },
          /*initOptions: {
            onLoad: "check-sso",
            silentCheckSsoRedirectUri:
              window.location.origin + "/assets/silent-check-sso.html",
          },
          enableBearerInterceptor: true,
          bearerExcludedUrls: ["/assets"],
          shouldUpdateToken: (request) => {
            return !(request.headers.get("token-update") === "false");
          },*/
        })
        .then(() => {
          this.keycloak.login({
            redirectUri: this.buildRedirectUri(realm),
          });
        });
    }
  }

  getParameterFromUrl(parameter: string) {
    const re = new RegExp(parameter + "=([a-z0-9-]+)&?");
    const results = re.exec(window.location.href);

    if (results) {
      return results[1];
    } else {
      return "";
    }
  }

  private getTenantIdFromCurrentUrl(): string {
    const searchTenantId = new URLSearchParams(window.location.search).get("tenantId")
      ?? new URLSearchParams(window.location.search).get("tenant_id");
    if (searchTenantId?.trim()) {
      return searchTenantId.trim();
    }

    const routeTenantId = this.route.snapshot.queryParamMap.get("tenantId")
      ?? this.route.snapshot.queryParamMap.get("tenant_id");
    if (routeTenantId?.trim()) {
      return routeTenantId.trim();
    }

    return sessionStorage.getItem("tenantId")?.trim() ?? "";
  }

  private hydrateTenantId(): void {
    this.tenantId = this.getTenantIdFromCurrentUrl();
    if (!this.tenantId) {
      return;
    }

    sessionStorage.setItem("tenantId", this.tenantId);
  }

  private buildRedirectUri(realm: string): string {
    const params = new URLSearchParams({ tenantId: realm });
    return `${environment.FRONTEND_URL}/gateway/auth?${params.toString()}`;
  }
}
